// Service	
import userService from "@/app/services/main/user/user-service.js";
import breedService from '@/app/services/main/breeds/breeds-service';

// Components
const FileUpload = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/_shared/_components/file-upload/file-upload.vue"
	)
	import addressFinderAutocompleteService from "@/app/services/main/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js";


// Mixins
import { mobileNumberMixins } from "@/app/mixins/utils/mobile-number-mixins.js";
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins"
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { addressMixins } from "@/app/mixins/utils/address-mixins"
import { errorFocusMixins } from "@/app/mixins/utils/error-focus-mixins"

// Constants
import { STATUS_CODES, USER_TYPE, SUCCESS_MSG } from "@/app/constants/constants";

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Third Party Libraries
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns';

export default {
    name: "WalkerSitterComponent",
    components: {
        FileUpload,
		DatePicker,
    },
	props: {
		userId: {
			default: ''
		}
	},
    mixins: [
        mobileNumberMixins, 
        dateMixins,
		toastMessageMixins,
		inputTextMixins,
		userMixins,
		imageUploadMixins,
		tableMixins,
		addressMixins,
		errorFocusMixins
    ],
    data() {
        return {
			userRole: null,
            isAPILoading: true,
            userWalkerSitterDetails: {},
            petOwnerFilter: "",
            modalContent: {},
            userDetails: {},
            imageSrc: null,
            isEditingDisabled: false,
			breedList: [],
			headerToggleCheckbox: false,
			isImageChanged: false,
			headerLabel:'',
			btnLabel: '',

            //walker sitter details
            inputFields: {
				firstName: '',
				lastName: '',
				email: '',
				selectedTimeZone: 'Australia/Sydney',
				coverage: '',
				bio: '',
				address: '',
				type:'',
				profileImageUpload: '',
				mobileNumber: '',
				freeOfCharge: false,
				perHour: 0.00,
				perDay: 0.00,
				latitude:'',
				longitude: '',
			},
			mobileNumberIsValid:true,

            roleOptions: [
				{ value: 'WALK', name: 'Walker'},
				{ value: 'SITT', name: 'Sitter'},
				{ value: 'WASI', name: 'Walker and Sitter'},
			],

			dateRange:'',
			selectedDays:[],
			startDate:'',
			endDate:'',
			selectAll:false,
			filter:'',
			selectedBreeds: [],
			addressList: [],
			isAddressLoading: false,
			errorDate: false,
			errorAvailableDate: false,
			theads: [
				{ name: 'Select Preferred Breeds', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: true, style: 'width: 90%;'  },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, hasToggle: true, style: 'width: 10%;' }
			],
			submitted: false
        };
    },
    watch: {
		selectedBreeds(newVal) {
			if (newVal) {
				if (newVal.length !== this.breedList.length) {
					this.headerToggleCheckbox = false;
				} else {
					this.headerToggleCheckbox = true;
				}
			}
		},
		'inputFields.type': {
			immediate: true,
			handler(newVal) {
				if(newVal) {
					this.userRole =  newVal.value 
				} else {
					this.userRole =  ''
				}
					
			},
			deep: true
		},
		'inputFields.coverage': {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					if ( newVal <= 100 ) {
						this.inputFields.coverage = newVal;
					} else {
						this.inputFields.coverage = newVal.slice(0, -1);
					}
				}
			},
			deep: true
		}
    },
    created() {
        this.getUserDetails();
        this.getUserWalkerSitterDetails();
		this.getBreedList();
    },
    computed: {
		displayBreeds() {
			if (this.filter.trim !== '') {
				return this.breedList.filter(breed => { 
					if (breed.name.toLowerCase().includes(this.filter.toLowerCase())) {
						return  breed;
					}
				});
			} else {
				return this.breedList;
			}
		},
		hasImage() {
			return !!this.imageSrc
		},
        validationRules() {
			let fields = {
				inputFields: {
					address: {},
					coverage: {},
					bio: {},
					profileImageUpload: {},
					type:{},
					mobileNumber: {}
				}
			};

			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);
			
			fields.inputFields.perDay = {};
			fields.inputFields.perHour = {};

			if (!this.inputFields.freeOfCharge && this.inputFields.type) {
				// Walker
				if (this.inputFields.type === 4) {
					fields.inputFields.perDay = {};
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perHour');
				} else if (this.inputFields.type === 5) {
					// Sitter
					fields.inputFields.perHour = {};
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perDay');
				} else {
					// Walker Sitter
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perHour');
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perDay');
				}
			}

			return fields;
		},
		isUserInfoChange() {

			const role = this.roleOptions.find(item => item.value === this.inputFields.type.value);

			const mobileNumber = this.userWalkerSitterDetails.mobileNumber || '';
			const mobileChange = this.inputFields.mobileNumber.replace('-', '') === mobileNumber.replace('-', '');
			const freeOfCharge = this.inputFields.freeOfCharge === this.userWalkerSitterDetails.freeOfCharge;
			const perHour = this.inputFields.perHour === this.userWalkerSitterDetails.perHour;
			const perDay = this.inputFields.perDay === this.userWalkerSitterDetails.perDay;
			 // Check if selectedBreeds arrays have same content
			 let breedsMatch = false
			 if(this.userWalkerSitterDetails.breed) {
				const getBreedData = this.userWalkerSitterDetails.breed.map(item => (item.id));
				breedsMatch = JSON.stringify(this.selectedBreeds) === JSON.stringify(getBreedData);
			 }
				

			return (
				this.inputFields.lastName === this.userWalkerSitterDetails.lastName &&
				this.inputFields.firstName === this.userWalkerSitterDetails.firstName &&
				this.inputFields.address.displayAddress === this.userWalkerSitterDetails.address &&
				this.inputFields.type.value === role.value &&
				this.selectedBreeds === this.userWalkerSitterDetails.breed &&
				parseInt(this.inputFields.coverage) === parseInt(this.userWalkerSitterDetails.coverage) &&
				this.inputFields.bio === this.userWalkerSitterDetails.biography &&
				!this.isImageChanged &&
				mobileChange &&
				freeOfCharge &&
				perHour &&
				perDay &&
				breedsMatch
			)
		},
    },

    methods: {
		isUpdateSchedule() {
			let disable = false	
			this.errorAvailableDate = false
			this.errorDate = false

			if (this.startDate ==='') {
				this.errorDate = true
				disable = true
			}

			if (this.endDate==='') {
				this.errorDate = true
				disable = true
			}

			if (this.selectedDays.length === 0) {
				this.errorAvailableDate = true
				disable = true
			}

			if(this.startDate ==='' && this.endDate==='' &&
				this.selectedDays.length === 0
			) {
				this.errorDate = false
				this.errorAvailableDate = false
				disable = false
			}

			return disable;
		},
		updateProfile() {
			this.$v.$touch();
			let isUpdateSchedule = this.isUpdateSchedule()
			this.submitted = true
			
			if (this.$v.$invalid || this.isUserInfoChange || isUpdateSchedule) {
				this.setFocusOnFirstErrorField()
				return;
			}

			this.isAPILoading = true
			let user = {
				firstName: this.inputFields.firstName,
				lastName: this.inputFields.lastName,
				address: this.inputFields.address.displayAddress,
				isImageChanged: this.isImageChanged
			};

			let walkerSitter = {
				biography: this.inputFields.bio,
				coverage: this.inputFields.coverage,
				breed: this.selectedBreeds,
				role: this.inputFields.type,
				freeOfCharge: this.inputFields.freeOfCharge,
				perHour: isNaN(this.inputFields.perHour) ? 0.00 : this.inputFields.perHour,
				perDay: isNaN(this.inputFields.perDay) ? 0.00 : this.inputFields.perDay
			};
			
			if (this.inputFields.latitude) {
				user.latitude = this.inputFields.latitude;
				user.longitude = this.inputFields.longitude;
			}

			if (this.inputFields.mobileNumber && this.inputFields.mobileNumber.length > 0) {
				walkerSitter.mobileNumber =  this.inputFields.mobileNumber.replace('-', '');
			}

			const availabilityDetails = {
				dateEndAt: this.endDate,
				dateStartAt: this.startDate,
				daysOfTheWeek: this.selectedDays
			}

			let walkerSitterDetails = {
				formData: {
					user,
					walkerSitter,
					availabilityDetails
					},userImage: this.inputFields.profileImageUpload[0]
					
				};

			userService.putWalkerSitterDetails(this.userId, walkerSitterDetails)
			.then(res => {
				this.isAPILoading = false;
					if (res.status === 204 ) {
						this.headerLabel = this.inputFields.type.name
						const { SUCCESS_UPDATE_PROFILE } = this.toastMessages.user();
						this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_PROFILE);
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true);
					}
					//refresh user details
					this.getUserWalkerSitterDetails();
			});	
		},

		filterBreed(event) {
			this.delayTyping(() => {
				this.filter = event.target.value;
			});
		},
		toggleApplicableBreed (event, breedId) {
			if (event.target.checked) {
				this.selectedBreeds.push(breedId);
			} else {
				const i = this.selectedBreeds.indexOf(breedId);
				this.selectedBreeds.splice(i,1);
			}
			
		},
		toggleSelectDeselect(event) {
			this.headerToggleCheckbox = event.target.checked;

			if (this.headerToggleCheckbox) {
				this.selectedBreeds = this.breedList.map(breed => { return breed.id; });
			} else {
				this.selectedBreeds = [];
			}
			
		},
		getBreedList() {
			this.isAPILoading = true;
			breedService.getBreeds()
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.breedList = res.data.data.filter((breed) => breed.id != 0)
						let countInActive = 0;
						
						this.breedList.map((breed) => {
							if (breed.status === "I") {
								countInActive++
							}
						})
						if (countInActive === 0) {
							this.headerToggleCheckbox = true
						}
					} else {
						this.showAPIErrorToast('Unable to fetch breeds list.', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isAPILoading = false;
				});
		},
		populateDateRangeData() {
			const { dateEndAt, dateStartAt, daysOfTheWeek } = this.userWalkerSitterDetails.availableDate;
			
			if (dateEndAt) {
				this.startDate = format(new Date(dateStartAt),'yyyy-MM-dd'); 
				this.endDate = format(new Date(dateEndAt),'yyyy-MM-dd'); 
				this.dateRange = [new Date(this.startDate),new Date(this.endDate)];
			}

			if (daysOfTheWeek){
				this.selectedDays  = daysOfTheWeek;
				if (daysOfTheWeek.length === 7 ) this.selectAll = true;
			}
			
		},
        getUserWalkerSitterDetails() {
            this.isAPILoading = true;
            userService.getUserWalkerSitterDetails(this.userId).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.userWalkerSitterDetails = res.data;
                    
                    this.imageSrc = res.data.imageURL;
                    this.inputFields.lastName = this.userWalkerSitterDetails.lastName
                    this.inputFields.firstName = this.userWalkerSitterDetails.firstName
					let typeData = this.roleOptions.filter(item => item.value === this.userWalkerSitterDetails.code)

					this.inputFields.type = typeData[0];
					this.userRole = this.userWalkerSitterDetails.code;
                    
                    this.inputFields.coverage = this.userWalkerSitterDetails.coverage;
					this.inputFields.bio = this.userWalkerSitterDetails.biography;
					let userAddress =  this.userWalkerSitterDetails.address
					this.inputFields.profileImageUpload =this.userWalkerSitterDetails.imageURL;
					
					if (typeof userAddress === 'string' && userAddress.toLowerCase() === 'null') {
						// element is a string and has value "null"
						userAddress = ''
					}
					this.inputFields.freeOfCharge = !!this.userWalkerSitterDetails.freeOfCharge;
					this.inputFields.perDay = isNaN(this.userWalkerSitterDetails.perDay) ? 0.00 : this.userWalkerSitterDetails.perDay;
					this.inputFields.perHour = isNaN(this.userWalkerSitterDetails.perHour) ? 0.00 : this.userWalkerSitterDetails.perHour;
					if (userAddress !== '') {
						this.inputFields.address = JSON.parse(`{"label": "address", "displayAddress": "${userAddress}", "full_address": "${userAddress}"}`) || "";
					} else {
						this.inputFields.address = ''
					}

					this.inputFields.latitude = this.userWalkerSitterDetails.latitude
					this.inputFields.longitude = this.userWalkerSitterDetails.longitude

					this.selectedBreeds = this.userWalkerSitterDetails.breed.map(item => (item.id));
					
					if (this.userWalkerSitterDetails.mobileNumber) {
						let data = this.userWalkerSitterDetails.mobileNumber.split('');
							data.splice(4, 0, '-');
						this.inputFields.mobileNumber = data.join('');
					}
					this.btnLabel = this.inputFields.type.name

					this.populateDateRangeData();
                    
					this.isAPILoading = false;
                } else if (res.status === STATUS_CODES.NOT_FOUND) {
                    this.isAPILoading = false;
                } else {
                    this.showAPIErrorToast("Unable to fetch user walker sitter details.", res);
                }
            });
        },
        getUserDetails() {
            this.isAPILoading = true;
            userService.getUserDetails(this.userId).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.userDetails = res.data;
                    this.isAPILoading = false;
					this.headerLabel = this.userInfo(res.data) 
                } else {
                    this.showAPIErrorToast("Unable to fetch user details.", res);
                }
            });
        },

        userInfo(info) {
            const { code } = info;
            return USER_TYPE[code]
        },

        async onUploadImage(event) {
			let valid = this.validateImage(event.target.files[0])

			// compress image if more than 2mb
			const file = await this.compressImage(event.target.files[0])

			// do nothing when user cancels Upload
			if (!valid) {
				// reset uploader
				this.$refs.uploader.value = ""
				return
			}

			this.fileBlob = [file]

			// show preview of pet image
			let reader = new FileReader()
			reader.onload = () => {
				this.imageToCrop = reader.result
				this.$refs.modalFileUpload.show()
			}

			reader.readAsDataURL(file)
		},

		setImageCrop({ image, blob }) {
			this.isImageChanged = true
			this.imageSrc = image
			this.fileBlob = blob
			this.inputFields.profileImageUpload = blob;
		},

		clearFileInput(event) {
			event.target.value = ""
		},

        onSelectedType(type) {
			this.inputFields.type = type;
		},
		mobileNumberFormat(event) {
			this.mobileNumberIsValid = true;
			let regexp = /^\d+$/;

			let updateData =regexp.test(event.target.value.charAt(event.target.value.length-1));
			
			if ( updateData && event.target.value.length <= 11 ) {
				if ( event.target.value.length === 5 && updateData ) {
					let data = event.target.value.split('');
					if ( event.target.value.charAt(4) === '-' ) {
						data.splice();
					} else {
						data.splice(4, 0, '-');
					}
					if ( !updateData ) {
						data.slice(0, -1); 
					}
					data = data.join('');
					
					this.inputFields.mobileNumber = data;
				} else {
					this.inputFields.mobileNumber = event.target.value;
				}
			} else {
				this.inputFields.mobileNumber= event.target.value.slice(0, -1);
			}
		},

		onPasteMobileNumber(event) {
			const pastedText = event.clipboardData.getData('text/plain');
			// Replace any non-numeric characters
			const cleanedValue = pastedText.replace(/[^0-9]/g, '');
			event.target.value = cleanedValue;

			if (!isNaN(cleanedValue)) {
				event.preventDefault(); // prevents the oninput from being called, making the value redundant
			}
		},
		checkFormat() {
			let regexp =  /^\d{4}-\d{6}$/;
			
			if (this.inputFields.mobileNumber !== null && this.inputFields.mobileNumber !=='' ) {
				this.mobileNumberIsValid = regexp.test(this.inputFields.mobileNumber);
			} else {
				this.mobileNumberIsValid = true;
			}
			this.$v.inputFields.mobileNumber.$touch();
		},
		checkCoverageValue() {
			if ( this.inputFields.coverage < 5 ) {
				this.inputFields.coverage = 5;	
			}
			this.$v.inputFields.coverage.$touch();
		},
		numberOnlyInput(event) {
			const charCode = (event.which) ? event.which : event.keyCode;

			if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
				event.preventDefault();
			} else {
				return true;
			}
		},
		onBlurRate(model) {
			this.$v.inputFields[model].$touch()
			
			const priceFormat = parseFloat(this['inputFields'][model]).toFixed(2);
			this['inputFields'][model] = isNaN(priceFormat) ? parseFloat('0').toFixed(2) : priceFormat;
		},
		check(val) {
			if (val === 'SelectAll') {
				if (!this.selectAll) {
					this.selectedDays  = ['SUN', 'FRI', 'THU', 'SAT', 'MON', 'TUE', 'WED'];
				} else {
					this.selectedDays = [];
				}
			}else{
				if (!this.selectedDays.includes(val)) {
					this.selectedDays.push(val);
					if(this.selectedDays.length === 7) this.selectAll = true;
				} else {
					this.selectAll = false;
					this.selectedDays = this.selectedDays.filter(day => {
						return day != val;
					});
				}
			}
			
		},
		setDate() {
			if (this.dateRange[0]) {
				this.startDate = format(new Date(this.dateRange[0]),'yyyy-MM-dd');
				this.endDate = format(new Date(this.dateRange[1]),'yyyy-MM-dd');
			} else {
				this.startDate = '';
				this.endDate = '';
			}
			this.isUpdateSchedule()
		},

		/**
		 *  start address
		 */
		findAddress(address) {
			if (address) {
				this.isAddressLoading = true;

				this.delayTyping(() => {
					this.getAutocompleteAddress(address);
				});
			}
		},
		getAutocompleteAddress(address) {
			addressFinderAutocompleteService.getAutocompleteAddress(address)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions.map(add => { 
							add.displayAddress = add.full_address
							add.label = add.id;
							return add; 
						});
						this.isAddressLoading = false;
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
						this.isAddressLoading = false;
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAddressLoading = false;
				});
		},
		async getAddressMetaData(address) {
			addressFinderAutocompleteService.getAddressMetaData(address.id)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { latitude, longitude } = res.data;
						this.inputFields.latitude = latitude
						this.inputFields.longitude = longitude
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
						this.isAddressLoading = false;
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAddressLoading = false;
				});
		},
		async onBlur(field) {
			if (field === 'address') {
				this.$v.inputFields.address.$touch();
				if (this.inputFields.address && this.inputFields.address.id) {
					await this.getAddressMetaData(this.inputFields.address);
				}
			}
		},
		async setSelectedAddress() {
			this.$v.inputFields.address.$touch();
	
			if (this.inputFields.address) {
				await this.getAddressMetaData(this.inputFields.address);
			}
		},
		/**
		 *  end address
		 */
    },
    validations() {
		return this.validationRules;
	}
};
